import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevronV2",
  "use": "chevronV2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevronV2\"><g data-name=\"icon - chevron right - 24px\" fill=\"none\"><path d=\"M0 0h24v24H0z\" /><path data-name=\"↳color\" d=\"M9.998 7.999l4 4-4 4\" stroke=\"#031425\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol